import {Grid} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import logo from "../../assets/images/logo.png";
import React from "react";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
    header: {
        flexGrow: 1,
        display: 'flex',
        height: '15mm',
        paddingRight: '10mm',
        flexDirection: 'row',
        backgroundColor: '#fecc00',
        flexWrap: 'nowrap'
    },
    gridLogo: {
        padding: '2mm',
        width: '50mm'
    },
    gridTitulo: {
        display: 'flex',
        flexGrow: 1,
        alignItems: 'center'

    },
    navLogo: {
        height: "30px",
        width: "158px",
        verticalAlign: 'middle'
    },

}));

const PageHeader = (props) => {
   const {titulo, subtitulo} = props;
   const classes = useStyles();

    return (
        <Grid container className={classes.header}>
            <Grid container className={classes.gridLogo}>
                <img src={logo} className={classes.navLogo} alt='logo'/>
            </Grid>
            <Grid container className={classes.gridTitulo}>
                <Typography>{titulo}</Typography>
                <Typography>{subtitulo}</Typography>
            </Grid>
        </Grid>
    );

}

export default (PageHeader)